module.exports = __webpack_public_path__ + "img/pos_s1_icon1.cd2bfb6f.png";